window.addEventListener('load', (event) => {
    let bannerSearch = document.getElementById('banner_search');
    if (bannerSearch) {
        const search_input = document.getElementById('search_term');
        search_input.addEventListener('input', async (event) => {
            if (event.target.value.length <= 1) {
                // wait until at least 3 characters to perform search
                return;
            }

            document.getElementById('search_all_button').href = '/?s='+event.target.value;

            document.querySelector('.search_results').classList.remove('hidden');
            document.querySelector('#close_results').classList.remove('hidden');
            document.querySelector('.searching_icon').classList.remove('hidden');
            do_search().then(
                (res) => {
                    if(res.success) {
                        document.querySelector('.searching_icon').classList.add('hidden');
                        document.getElementById('search_results_wrapper').innerHTML = res.data.results
                        document.querySelector('#search_results_wrapper').classList.remove('hidden');
                        document.querySelector('.search_all_wrapper').classList.remove('hidden');
                    }else{
                        document.querySelector('.searching_icon').classList.add('hidden');
                        document.getElementById('search_results_wrapper').innerHTML = '<span style="padding: 10px;width: 100%;display: flex;">'+res.data.message+'</span>';
                        document.querySelector('#search_results_wrapper').classList.remove('hidden');
                        document.querySelector('.search_all_wrapper').classList.remove('hidden');
                    }
                }
            ).catch(console.error)
        })


        document.querySelector('#close_results').addEventListener('click', () => {
            document.querySelector('.search_results').classList.add('hidden');
            document.querySelector('.searching_icon').classList.add('hidden');
            document.querySelector('#close_results').classList.add('hidden');
            document.querySelector('#search_results_wrapper').classList.add('hidden');
            document.getElementById('search_term').value = '';
        })
    }




});





const do_search = async () => {
    const response = await
        fetch('/wp-json/dod/v1/search/?search_term=' + document.getElementById('search_term').value + '&search_type=' + document.getElementById('search_type').value,
            {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer',
            });

    if (response.ok) {
        const jsonValue = await response.json(); // Get JSON value from the response body
        return Promise.resolve(jsonValue);
    } else {
        return Promise.reject('An error has occurred');
    }
}